export const url = 'https://126e-66-94-100-156.ngrok.io'

export const header = {
    'Content-Type': 'application/json'
}
export const header2 = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
}
